import React, { useState, useEffect } from "react";
import axios from "axios";
const StudentFees = () => {
    const [activeTab, setActiveTab] = useState('pay-fees');
    
    const [studentFeesData, setStudentFeesData] = useState([]);
    useEffect(() => {
        axios.get("/api/student/get-student-fees", { withCredentials: true })
            .then(response => {
                setStudentFeesData(response.data);
            })
            .catch(error => {
                console.error("Error fetching student fees:", error);
            });
    }, []);

    //const invoices = [
    //    { head : "Tution Fee - 5000 \n Term Fee - 5000", month: "April", total_amt: "10000", paid_amt: "0", balance_amt: "10000" },
    //];
    const invoices = studentFeesData;
    return (
        <div className="row gy-44">
            <div className="col-xxl-6">
                <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
                    <div className="card-header py-16 px-10 bg-base border border-end-0 border-start-0 border-top-0">
                        <h3 className="mb-0">Fees</h3>
                    </div>
                    <div className="card-body p-10 pt-10">
                        
                        <ul className="nav button-tab nav-pills mb-16" role="tablist">
                            <li className="nav-item" role="presentation">
                            <button
                                className={`border nav-link fw-semibold text-primary-light radius-4 px-16 py-10 ${activeTab === 'pay-fees' ? 'active' : ''}`}
                                type="button"
                                role="tab"
                                onClick={() => setActiveTab('pay-fees')}
                            >
                                Pay Fees
                            </button>
                            </li>
                            <li className="nav-item" role="presentation">
                            <button
                                className={`border nav-link fw-semibold text-primary-light radius-4 px-16 py-10 ${activeTab === 'transaction-history' ? 'active' : ''}`}
                                type="button"
                                role="tab"
                                onClick={() => setActiveTab('transaction-history')}
                            >
                                Transaction History
                            </button>
                            </li>
                        </ul>
                        
                        <div className="tab-content">
                            
                            {activeTab === 'pay-fees' && (
                                <div className="tab-pane fade active show" role="tabpanel">
                                    
                                    <div className="table-responsive">
                                        <table className="table-mobile-view mb-0" style={{ width: "100%" }}>
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "20%" }}>Month</th>
                                                    <th style={{ width: "20%" }}>Total Amt</th>
                                                    <th style={{ width: "20%" }}>Paid Amt</th>
                                                    <th style={{ width: "20%" }}>Balance (To Pay Amt)</th>
                                                    <th style={{ width: "20%" }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {invoices.map((invoice, index) => (
                                                    <tr key={index}>
                                                        <td><strong>{invoice.month}</strong></td>
                                                        <td><strong>{invoice.total_amt}</strong></td>
                                                        <td><strong>{invoice.paid_amt}</strong></td>
                                                        <td><strong>{invoice.balance_amt}</strong></td>
                                                        <td>
                                                            <a href="#!" className="btn btn-info-600">
                                                            Paid
                                                            </a>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    
                                </div>
                            )}
                            {activeTab === 'transaction-history' && (
                                <div className="tab-pane fade active show" role="tabpanel">
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="flex-grow-1">
                                            
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default StudentFees;